import { Component, Input, Output, OnInit, AfterViewInit, EventEmitter, ViewChild, ElementRef, Directive } from '@angular/core';

declare var FunctionCall: any, InitializeObjects: any;
declare var mnClient: any, mnLeftLogo: any, mnRightLogo: any, RB_UIMgnt: any,
    putOnWait: any, HotSpotHtml5: any, Test: any, TestFunctions: any, Navigation: any, CloseTest: any, objSequenceSrcClass: any, Summary: any, SetUI_Controls: any;
import { TaketestComponent } from '../../app.taketest';

@Component({
    selector: 'sanmarino-footer',
    templateUrl: 'app.footer.html'
})
export class SanMarinoFooterComponent implements OnInit {
    private static instance: SanMarinoFooterComponent;
    public Attributes = {
        spnImg: 'spnImg',
        spnSNA: 'spnSNA',
        navImg: 'navImg',
        navLi: 'navLi'
    }
    constructor(private elRef: ElementRef) { }
    @Input() SectionDetailsList: any;
    @Input() TestInfo: any;
    @Output() ParentFunctionCall = new EventEmitter();
    FunctionCall(arg1, arg2, arg3) {
        var obj = {
            arg1: arg1,
            arg2: arg2,
            arg3: arg3
        }
        this.ParentFunctionCall.emit(obj);
    }
    ngOnInit() {
        try {
            var footerDv = $('.tpl_qno_pad');
            $('#dvFooterControl').append(footerDv);
        }
        catch(e) { }
    }

}

//format the   select a blank questions





// WEBPACK FOOTER //
// E:/Workspace/TestandAssessment/Manifest/TestPlayer/TestDelivery.TestPlayer/src/app/Test/Footers/SanMarino/app.footer.ts